import React from 'react';
import { string } from 'prop-types';

import CSS from './styles.css';


const NotificationsViews = ({ rid }) => {
  return (
    <div className={ CSS['container'] }>
      <div className={ CSS['notification'] } role="alert" aria-labelledby="notificationTitle" aria-describedby="notificationDesc">

        <p id="notificationTitle" className={ CSS['text'] }>
          For some reason, we couldn't load your e-Book.
          We're sorry about this! A few things to try:
        </p>

        <ul id="notificationDesc">
          <li className={ CSS['list-item'] }>
            <span>Refresh your browser in 60 seconds.</span>
          </li>
          <li className={ CSS['list-item'] }>
            <span>Go to your course home and try again.</span>
          </li>
        </ul>

        <p className={ CSS['text'] }>
          If these don't work look <a rel="noopener noreferrer" href="https://community.macmillan.com/community/digital-product-support" target="_blank">here</a>.
        </p>
        <div className={ CSS['rid'] }>
          { rid }
        </div>
      </div>
    </div>
  );
};

NotificationsViews.propTypes = {
  rid: string
};


export default NotificationsViews;
